import { Add, Remove } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import Announcement from '../components/Announcement';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { mobile } from '../responsive';
import StripeCheckout from 'react-stripe-checkout';
import { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";

import {userRequest} from "../requestMethods";
import { cleanCart } from "../redux/reduxCart";
import { deleteProduct } from "../redux/apiCalls";
// import { deletePrice } from '../redux/apiCalls';
import { deleteTotalSuccess, deleteQuantitySuccess } from '../redux/reduxCart';

const KEY = process.env.REACT_APP_STRIPE;


const Container = styled.div`
    
`;
const Wrapper = styled.div`
    padding: 20px;
    ${mobile({ padding: "10px"})}
`;
const Title = styled.h1`
    font-weight: 300;
    text-align: center;
`;
const Top = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
`;
const TopButton = styled.button`
    padding: 10px;
    font-weight: 600;
    cursor: pointer;
    border: ${(props) => props.type === "filled" && "none"};
    background-color: ${(props) => 
        props.type === "filled" ? "black" : "transparent"};
    color: ${(props) => props.type === "filled" && "white"};
`;
const TopTexts = styled.div`
    ${mobile({ display: "none"})}
`;
const TopText = styled.span`
    text-decoration: underline;
    cursor: pointer;
    margin: 0px 10px;
`;
const Bottom = styled.div`
    display: flex;
    justify-content: center;
    ${mobile({ flexDirection: "column"})}
`;
const Info = styled.div`
    flex: 3;
`;
const Product = styled.div`
    display: flex;
    justify-content: space-between;
    ${mobile({ flexDirection: "column"})}
`;
const ProductDetail = styled.div`
    flex: 2;
    display: flex;
`;
const Image = styled.img`
    width: 200px;
`;
const Details = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
`;
const ProductName = styled.span`
    
`;
const ProductId= styled.span`
    
`;
const ProductColor = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: ${(props) => props.color};
`;
const ProductSize = styled.span`
    
`;
const PriceDetail = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
const ProductAmountContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 20px;
`;
const ProductAmount = styled.div`
    font-size: 24px;
    margin: 5px;
    ${mobile({ margin: "5px 15px"})}
`;
const ProductPrice = styled.div`
    font-size: 30px;
    font-weight: 200;
    ${mobile({ marginBottom: "20px"})}
`;
const Hr = styled.hr`
  background-color : #eee;
  border: none;
  height: 2px;
`;
const Summary = styled.div`
    flex: 1;
    border: 0.5px solid lightgray;
    border-radius: 10px;
    padding: 20px;
    height: 50vh;
`;
const SummaryTitle = styled.h1`
    font-weight: 200;
`;
const SummaryItem = styled.div`
    margin: 30px 0px;
    display: flex;
    justify-content: space-between;
    font-weight: ${(props) => props.type === "total" && "00"};
    font-size: ${(props) => props.type === "total" && "24px"};
`;
const SummaryItemText = styled.span`
    
`;
const SummaryItemPrice = styled.span`
    
`;
const Button = styled.button`
    width: 50%;
    padding: 10px;
    background-color: #eb9292;
    color: white;
    font-weight: 600;
    ${mobile({ width: "50%"})}
`;

const Cart = () => {
    const cart = useSelector((state)=>state.cart);
    // console.log(cart);
    const dispatch = useDispatch();
    const [stripeToken, setStripeToken] = useState(null);
    const navigate = useNavigate()
    const onToken = (token) =>{
        setStripeToken(token);
    };
    // console.log(stripeToken)
    useEffect(() =>{
        
        const makeRequest = async () =>{
            try{
                const res = await userRequest.post(
                    "/ckeckout/payment", {
                        tokenId: stripeToken.id,
                        amount: cart.total * 100,
                    }
                );
                //console.log(res.data);
                navigate("/success", {state: res.data});
                {handleClickPayment()};
            }catch(err) {
                //console.log(err)
            }
        };
        stripeToken && makeRequest();
    },[stripeToken, cart.total, navigate, dispatch])

    
    const handleClick = () => {
        if (window.confirm('Ви бажаєте очистити корзину?')) {
            dispatch(cleanCart());
        };
    };
  
    const handleClickPayment = () => {
        
            dispatch(cleanCart());
        ;
    };
  
    const handleDelete = (_id) => {
        if (window.confirm('Ви дійсно бажаєте видалити?')) {
          deleteProduct(_id, dispatch);
        }
      };
    const handleDeleteProdTotal = (total) => {
        dispatch(deleteTotalSuccess(total));
        // console.log(total) 
      };
    const handleDeleteQuantity = (quantity) => {
        dispatch(deleteQuantitySuccess(quantity));
        // console.log(quantity) 
      };
   
  return (
    <Container>
        <Navbar />
        <Announcement />
            <Wrapper>
                <Title>YOUR BAG</Title>
                <Top>
                    <TopButton>
                        <Link style={{ textDecoration: 'none'}} to="/"> 
                            CONTINUE SHOPPING
                        </ Link>
                    </TopButton>
                    {/* <TopTexts>
                        <TopText>Shopping Bag(2)</TopText>
                        <TopText>Your Wishlist (0)</TopText>
                    </TopTexts> */}
                    <TopButton type="filled">CHECKOT NOW</TopButton>
                </Top>
                <Button onClick={handleClick}>Clean cart</Button>
                <Bottom>
                    <Info>  
                        {cart.products.map((product, i)=>(
                        <Product key={i}>
                            <ProductDetail>
                                <Image src={product.img} />
                                <Details>
                                    <ProductName><b>Product:</b>{product.title}</ProductName>
                                    <ProductId><b>ID:</b>{product._id}</ProductId>
                                    <ProductColor color={product.color} />
                                    <ProductSize><b>Size:</b>{product.size}</ProductSize>
                                    {/* <Button onClick={() => handleClickDelProd(product._id)}>Remove</Button> */}
                                    {/* <Button onClick={() => handleDelete(product._id)}>Remove</Button> */}
                                    <Button onClick={() => {handleDelete(product._id); handleDeleteProdTotal(product.price * product.quantity); handleDeleteQuantity(product.quantity)}}>Remove</Button>
                                    
                                </Details>
                            </ProductDetail>
                            <PriceDetail>
                                <ProductAmountContainer>
                                    <Add />
                                    <ProductAmount>{product.quantity}</ProductAmount>
                                    <Remove>
                                        
                                    </Remove>
                                </ProductAmountContainer>
                                <ProductPrice>$ {product.price*product.quantity}</ProductPrice>
                            </PriceDetail>
                        </Product>
                        ))}
                        <Hr />
                        
                    </Info>
                    <Summary>
                        <SummaryTitle>ORDER SUMMARY</SummaryTitle>
                        <SummaryItem>
                            <SummaryItemText>Subtotal</SummaryItemText>
                            <SummaryItemPrice>$ {cart.total}</SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem>
                            <SummaryItemText>Estimated shipping</SummaryItemText>
                            <SummaryItemPrice>$ 0</SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem>
                            <SummaryItemText>Discount</SummaryItemText>
                            <SummaryItemPrice>$ {cart.discount}</SummaryItemPrice>
                        </SummaryItem>
                        <SummaryItem type="total">
                            <SummaryItemText>Total</SummaryItemText>
                            <SummaryItemPrice>$ {cart.total}</SummaryItemPrice>
                        </SummaryItem>
                        <StripeCheckout
                            name="Shop"
                            // image="./logo192.png"
                            billingAddress
                            shippingAddress
                            description={`Ваша сума $${cart.total}`}
                            amount={cart.total*100}
                            token={onToken}
                            stripeKey={KEY}
                            >
                                <Button>CHEKOUT NOW</Button>
                            </StripeCheckout>
                        
                    </Summary>
                </Bottom>
            </Wrapper>
        <Footer />
      
    </Container>
  )
}
    
export default Cart
